export const HOMEPAGE_REDESIGN_EXPERIMENT = 'prebooking_hp_search_widget_redesign';
